import { render } from "./header-component.vue?vue&type=template&id=cc27bfa8&scoped=true"
import script from "./header-component.vue?vue&type=script&lang=js"
export * from "./header-component.vue?vue&type=script&lang=js"

import "./header-component.vue?vue&type=style&index=0&id=cc27bfa8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc27bfa8"]])

export default __exports__